import 'vite/modulepreload-polyfill'

import Vue                 from 'vue'
import VueApollo           from 'vue-apollo'
import Cardstock           from './Cardstock.vue'
import VueRouter           from 'vue-router'
import router              from './routes'
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'
import { FontAwesomeIcon }  from '@fortawesome/vue-fontawesome'
import PortalVue            from 'portal-vue'
import VueProgressBar       from 'vue-progressbar'
import loadFontAwesomeIcons from './fontAwesome'
import apolloProvider       from './apolloProvider'
import VueObserveVisibility from 'vue-observe-visibility'
import VueChatScroll        from 'vue-chat-scroll'
import VBodyScrollLock      from 'v-body-scroll-lock'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

Vue.config.productionTip = false

Vue.use(VueApollo)
Vue.use(VueRouter)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(PortalVue)
Vue.use(VBodyScrollLock)
Vue.use(VueObserveVisibility)
Vue.use(VueProgressBar, {
  thickness: '5px'
})
Vue.use(VueChatScroll)
loadFontAwesomeIcons()
Vue.component('font-awesome-icon', FontAwesomeIcon)

Sentry.init({
  dsn: "https://a8ca28539a56488c8eb1e3404c61f51d@o57400.ingest.sentry.io/5403718",
  integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true})],
});

// From https://jsfiddle.net/Linusborg/Lx49LaL8/
Vue.directive('click-outside', {
  bind: function(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) { warn += `Found in component '${compName}'` }

      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler

    // add Event Listeners
    document.addEventListener('click', handler)
  },

  unbind: function(el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null

  }
})


let cardstockElement = "#cardstock"

initCardstock()

function initCardstock() {
  if (window.hasInitializedCardstock) {
    console.warn("Cardstock: [warning] hasInitializedCardstock is true")
    return
  } else {
    window.hasInitializedCardstock = true
  }

  let loadCardstock = function(e) {
    if(!document.querySelector(cardstockElement)) {
      console.warn("Cardstock: [warning] Element with id #cardstock was not found")
      return
    }

    if (e.type == 'pageshow' && window.cardstock && !window.cardstock._isDestroyed) {
      console.warn("Cardstock: [warning] Non-destroyed Cardstock element found")
      return
    }

    window.Bus = new Vue();

    window.Cardstock = new Vue({
      el: '#cardstock',
      apolloProvider,
      router,
      render: h => h(Cardstock)
    })
  }

  document.addEventListener("DOMContentLoaded", loadCardstock)
}

console.log("Hello from Cardstock spa.js")
